<template>
  <b-card title="">
    <h3 class="text-primary font-weight-bold mb-2">อัพเดทข้อมูลคิวด่านชายแดน</h3>

    <b-row>
      <b-col md="6">
        <h5 class="h4 font-weight-bold"> AL Code</h5>
        <b-form-group class="font-weight-bold" label="" label-for="IdCode">
          <b-form-input id="IdCode" v-model="formUser.IdCode" placeholder=" AL Code" />
        </b-form-group>
      </b-col>
      <b-col md="6"></b-col>
      <b-col md="6">
        <b-form-group>
          <h5 class="h4 font-weight-bold">เลือกวันที่เริ่มต้นลงทะเบียน</h5>
          <flat-pickr v-model="startDate" class="form-control" :config="DateConfig" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <h5 class="h4 font-weight-bold">เลือกวันที่สิ้นสุดลงทะเบียน</h5>
          <flat-pickr v-model="endDate" class="form-control" :config="DateConfig" />
        </b-form-group>
      </b-col>
      <b-col md="6"></b-col>
      <b-col md="6"></b-col>



      <b-col cols="12">
        <b-button variant="primary" type="submit" @click.prevent="getDataTable" :disabled="isLoading">
          <template v-if="isLoading">
            <b-spinner small type="grow" class="mr-1" />
            กำลังค้นหา...
          </template>
          <template v-else>
            ค้นหา
          </template>
        </b-button>
      </b-col>
      <!-- <b-col md="6">
        <br />
        <b-button variant="primary" @click.prevent="getDataTable"> ค้นหา </b-button>
      </b-col> -->
      <br />
      <b-col md="6"></b-col>
      <b-col md="6">
        <br />
        <h3 class="text-primary font-weight-bold mb-2">
          ตารางแสดงรายการจองคิวที่ศุนย์
        </h3>
      </b-col>
      <b-col md="6"></b-col>
      <b-col md="6" sm="4" class="my-1">
        <b-form-group class="mb-0">
          <label class="h5 d-inline-block text-sm-left mr-50">จำนวนต่อหน้า</label>
          <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50"
            @change="handleItemsPerPageChange" />
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-form-group label="ค้นหา" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput"
          class="h5 mb-0">
          <b-input-group size="sm">
            <b-form-input id="filterInput" v-model="filter" type="search" placeholder="พิมพ์เพื่อค้นหา" />
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">ยกเลิก</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-col cols="12">
      <b-table striped hover responsive :current-page="currentPage" :items="items" :fields="fields"
        :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter"
        :filter-included-fields="filterOn" @filtered="onFiltered">
        <template #head(select)>
          <b-form-checkbox :indeterminate="isIndeterminate" :checked="allSelected"
            @change="toggleSelectAll"></b-form-checkbox>
        </template>
        <template #cell(processingStatus)="data">
          <div class="d-flex flex-column">
            <div v-for="(status, index) in parsedStatus(data.item.processingStatus)" :key="index"
              class="d-flex align-items-center mb-1">
              <!-- Step number -->
              <!-- <span class="badge badge-secondary mr-2">{{ index + 1 }}</span> -->

              <!-- ชื่อขั้นตอน -->
              <!-- <span class="font-weight-bold mr-2">{{ Object.keys(status)[0] }}:</span> -->

              <!-- ค่า + สีตามผล -->
              <span :class="[
                'badge',
                badgeClass(Object.values(status)[0])
              ]">
                {{ Object.values(status)[0] }}
              </span>
            </div>
          </div>
        </template>
        <!-- Checkbox per row -->
        <template #cell(select)="row">
          <b-form-checkbox v-model="row.item._selected" @change="updateSelectAllState"></b-form-checkbox>
        </template>

        <template #cell(action)="props">
          <b-button variant="outline-primary" size="sm" @click="handlePrint(props.item)" title="ปริ้น">
            <feather-icon icon="PrinterIcon" />
          </b-button>
        </template>
      </b-table>
    </b-col>

    <!-- Pagination -->
    <b-card v-show="true" class="p-0 mb-1" no-body>
      <b-nav class="navbar d-flex justify-content-between bd-highlight flex-wrap">
        <div>
          Showing {{ (currentPage - 1) * perPage + 1 }} to
          {{ Math.min(currentPage * perPage, totalRows) }} of {{ totalRows }} entries
        </div>
        <div class="bd-highlight">
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" @input="handlePageChange"
            class="mb-0" first-text="First" prev-text="Prev" next-text="Next" last-text="Last" align="left"
            hide-goto-end-buttons />
        </div>
      </b-nav>
    </b-card>

    <b-row class="justify-content-center mt-3">
      <b-col cols="8" class="d-flex justify-content-center">
        <b-button variant="success" @click="MakeQueue" :disabled="!hasSelected"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'">
          ดำเนินการต่อ
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BNav,
  BCard,
  BCardText,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import store from "@/store/index";
import API from "@/connect/config";
import axios from "axios";
import Ripple from "vue-ripple-directive";
import { setTextStyle } from "echarts/lib/util/graphic";

export default {
  directives: {
    Ripple,
  },
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCard,
    BCardText,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BNav,
    flatPickr,
  },
  data() {
    return {
      perPage: 100,
      pageOptions: [25, 50, 100],
      totalPage: 0,
      totalRows: 0,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      isBusy: false,
      items: [],
      filter: null,
      filterOn: [],
      selectedBorder: null,
      fields: [
        { key: "select", label: "", sortable: false },
        { key: "no", label: "ลำดับที่" },
        { key: "IdCode", label: "เลขพาสปอร์ต/เลขที่ประจำตัว13หลัก" },
        { key: "prefix", label: "คำนำหน้า" },
        { key: "firstname", label: "ชื่อ" },
        { key: "lastname", label: "นามสกุล" },
        { key: "gender", label: "เพศ" },
        { key: "processingStatus", label: "สถานะลงทะเบียน" },
        // { key: "DateofBirth", label: "วันเดือนปีเกิด" },
        { key: "createdAtFormatted", label: "วันที่ลงทะเบียน" },
      ],
      startDate: new Date(),
      endDate: new Date(),
      showError: false,
      DateConfig: {
        dateFormat: "Y-m-d", // format ที่ใช้ส่งจริง
        altInput: true,
        altFormat: "d-m-Y",  // format ที่แสดงผล
      },
      formUser: {
        reqcode: "",
        IdCode: "",
      },
      isLoading: false,
    };
  },
  computed: {
    allSelected() {
      return (
        this.items.length > 0 && this.items.every((item) => item._selected)
      );
    },
    isIndeterminate() {
      const total = this.items.length;
      const selected = this.items.filter((i) => i._selected).length;
      return selected > 0 && selected < total;
    },
    hasSelected() {
      return this.items.some((item) => item._selected);
    },
  },
  created() {
    const jwt = JSON.parse(localStorage.getItem("company_jwt"));
    console.log("JWT:", jwt);
    // this.getDataTable();
  },
  methods: {
    parsedStatus(statusString) {
      try {
        return JSON.parse(statusString);
      } catch (e) {
        return [];
      }
    },
    badgeClass(value) {
      if (["สำเร็จ", "อนุมัติ", "ผ่าน"].includes(value)) {
        return "badge-success"; // เขียว
      } else if (["รอดําเนินการ", "กำลังดำเนินการ"].includes(value)) {
        return "badge-warning"; // เหลือง
      } else {
        return "badge-danger"; // แดง
      }
    },
    statusText(status) {
      switch (status) {
        case 'confirmed':
          return 'อนุมัติ'
        case 'rejected':
          return 'ยกเลิก'
        case 'pending':
          return 'รอดำเนินการ'
        default:
          return status
      }
    },
    validate() {
      // ไม่บังคับกรอกข้อมูล
      return true;
    },
    async Getdata() {
      if (!this.validate()) return;
      await this.getDataTable();
    },
    async getDatauserFromCompany(_userId) {
      try {
        const jwt = JSON.parse(localStorage.getItem("company_jwt"));
        const params = {
          companyId: jwt.companyId,
          userId: _userId,
        };
        console.log("Request Params", params);
        const res = await axios.get(`${API}userFromCompany`, {
          params,
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        });
        console.log("API Response", res.data)
        return res.data.message.data;
      } catch (err) {
        console.error("❌ Error:", err.response?.data || err.message);
      } finally {
        this.isBusy = false;
      }

      return;

    },
    async getDataTable() {
      this.isLoading = true;
      // ตัวอย่างดึงข้อมูลจาก store (หรือ API)
      console.log("startDate type:", typeof this.startDate, this.startDate); // ⬅ เพิ่มบรรทัดนี้
      console.log(this.startDate); // ⬅ เพิ่มบรรทัดนี้

      try {
        const jwt = JSON.parse(localStorage.getItem("company_jwt"));
        const formatDate = (dateObj) => {
          if (typeof dateObj === 'string') {
            dateObj = new Date(dateObj);
          }
          if (!(dateObj instanceof Date) || isNaN(dateObj)) return "";
          const day = String(dateObj.getDate()).padStart(2, "0");
          const month = String(dateObj.getMonth() + 1).padStart(2, "0");
          const year = String(dateObj.getFullYear());
          return `${day}-${month}-${year}`;
        };

        const startStr = formatDate(new Date(this.startDate));
        const endStr = formatDate(new Date(this.endDate));

        const [dayExit, monthExit, yearExit] = startStr.split("-");
        const [dayEntry, monthEntry, yearEntry] = endStr.split("-");

        let params = {
          userId: jwt.userId,
          includeCompany: 'true',
          startDate: `${yearExit}${monthExit}${dayExit}`,
          endDate: `${yearEntry}${monthEntry}${dayEntry}`,
          emptyStationName: 'true',
          _page: this.currentPage,
          _limit: this.perPage,
          _sort: "-1",
        };

        if (this.formUser.IdCode && this.formUser.IdCode.trim() !== "") {
          params.IdCode = this.formUser.IdCode;
        }

       console.log("Request Params", params);

        const res = await axios.get(`${API}pendingEntry`, {
          params,
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        });
        console.log("API Response", res.data.message.data);


        if (!res.data.message.data || !res.data.message.total) {
          this.items = [];
          this.totalRows = 0;
          return;
        }
        const results = await Promise.all(
          res.data.message.data.map(async (item, index) => {
            const date = new Date(item.createdAt);
            const formattedDate = `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
            console.log("Item UserId:", item.userId);
            const datausername = await this.getDatauserFromCompany(item.userId); // <- เรียก async ได้
            console.log("datausername", datausername);
            var sp = item.createdAt.split(' ')// `${date.getFullYear()}-${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}`;
            var createdAtFormatted_img = sp[0].split('/')
            return {
              ...item,
              no: index + 1,
              //createdAtFormatted: formattedDate,
              createdAtFormatted: createdAtFormatted_img[0] + '/' + createdAtFormatted_img[1] + '/' + createdAtFormatted_img[2],//item.createdAt,

              _selected: false,
              // datausername, // <- ใส่ข้อมูลที่ได้จาก async ไปใน object
              prefix: datausername ? datausername.prefix : '',
              firstname: datausername ? datausername.firstname : '',
              lastname: datausername ? datausername.lastname : '',
              gender: datausername ? datausername.gender : '',
            };
          })
        );
        // const results = res.data.message.data.map((item, index) => {
        //   const date = new Date(item.createdAt);
        //   const formattedDate = `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
        //   // const datausername = await getDatauserFromCompany()
        //   return {
        //     ...item,
        //     no: index + 1, // ลำดับเริ่มที่ 1
        //     createdAtFormatted: formattedDate,
        //     _selected: false, // เพิ่มให้ทุกแถวมี property นี้
        //   };
        // });

        console.log(results);
        this.items = results;
        this.totalRows = res.data.message.total;
      } catch (err) {
        console.error("❌ Error:", err.response?.data || err.message);
      } finally {
        this.isBusy = false;
        this.isLoading = false;
      }
      return;
    },
    handlePrint(item) {
      console.log("พิมพ์ข้อมูล:", item);
    },
    async MakeQueue() {
      const selectedUsers = this.items.filter((item) => item._selected);
      console.log(selectedUsers);
      store.commit("addChang", selectedUsers);

      this.$router.push({ name: "updatequeue" });
    },
    async handlePageChange(page) {
      this.currentPage = page;
      this.items = [];
      await this.getDataTable();
    },
    async handleItemsPerPageChange() {
      this.items = [];
      this.currentPage = 1;
      await this.getDataTable();
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    toggleSelectAll(checked) {
      this.items.forEach((item) => {
        item._selected = checked;
      });
      this.updateSelectAllState();
    },
    updateSelectAllState() {
      // Vue will recalculate allSelected and isIndeterminate automatically
      // const total = this.items.length;
      // const selected = this.items.filter((i) => i._selected).length;
      // this.allSelected = selected === total;
      // this.isIndeterminate = selected > 0 && selected < total;
    },
  },
};
</script>
